import { Outlet } from "react-router";

export default function LayoutWallOfLove() {
	return (
		<main className="min-h-screen">
			<Outlet />
		</main>
	);
}
